export default __webpack_public_path__ + "media/custom-branding3x.7ae90c8c.png";